import React from 'react';
import { User, Mail } from 'lucide-react';
import Hero from '../components/Hero';
import PageTransition from '../components/PageTransition';

const Contact = () => {
  return (
    <PageTransition>
      <main className="flex-1 flex flex-col">
      <Hero page="contact" />
      <div className="bg-gradient-to-br from-purple-50 to-blue-50 py-20 flex-1 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="bg-white rounded-2xl shadow-md p-8 relative z-10">
            <form className="space-y-6">
              <div>
                <label className="block text-gray-700 mb-2">Name</label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="Your name"
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="email"
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="Your email"
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Message</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent h-32"
                  placeholder="Your message"
                ></textarea>
              </div>
              <button className="w-full bg-purple-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors">
                Send Message
              </button>
            </form>
          </div>
          <img 
            src="/correio.png" 
            alt="Mail decoration" 
            className="absolute -bottom-8 -right-24 w-48 h-48 object-contain z-20 hidden lg:block"
          />
        </div>
      </div>
    </main>
    </PageTransition>
  );
};

export default Contact;